module.exports = __webpack_public_path__ + "static/media/minoan_text_07.9e78a701.jpg";